<script setup lang="ts">
import { Toaster } from '@eci-saas/ui/components/sonner'
import { useThemeStore } from './stores/theme'

const { isDark } = storeToRefs(useThemeStore())
</script>

<template>
  <Toaster :theme="isDark ? 'dark' : 'light'" rich-colors />
  <RouterView />
</template>
